import Vue from 'vue'
import Router from 'vue-router'
import Prototype from '@/views/prototype.vue'

Vue.use(Router)

const Input = () => import(/* webpackChunkName: "input" */ '@/views/input.vue')
const Result = () => import(/* webpackChunkName: "result" */ '@/views/result.vue')
const ContactForm = () => import(/* webpackChunkName: "contact-form" */ '@/views/contact-form.vue')
const ContactSuccess = () => import(/* webpackChunkName: "contact-success" */ '@/views/contact-success.vue')

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',

    routes: [
        {
            path: '/',
            name: 'home',
            component: Input,
        },
        {
            path: '/prototype',
            name: 'prototype',
            component: Prototype,
        },
        {
            path: '/result',
            name: 'result',
            component: Result,
        },
        {
            path: '/contact-us',
            name: 'contact-us',
            component: ContactForm,
        },
        {
            path: '/contact-success',
            name: 'contact-success',
            component: ContactSuccess,
        },
    ]
})
